import { render } from "./VabeneDeletedOrdersPage.vue?vue&type=template&id=7ba8b868&ts=true"
import script from "./VabeneDeletedOrdersPage.vue?vue&type=script&lang=ts"
export * from "./VabeneDeletedOrdersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__